import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";
import { useUpgradePlanContext } from "./../UpgradePlanContext";
import { isDowngrade } from "./../planActionHelpers";
import { PlanFeaturesList } from "./PlanFeaturesList";
import { PlanLineItems } from "./PlanLineItems";
import { getDisplayName, getDisplaySubheading } from "./helpers";

const i18nRoot = "pricing_plans.upgrade_modal";

interface DowngradePlanDetailsProps {
  hideModal: () => void;
  onSubmitHandler: () => void;
  subheading?: string;
}

export const DowngradePlanDetails = ({
  subheading = "",
  hideModal,
  onSubmitHandler,
}: DowngradePlanDetailsProps) => {
  const { plan, emailHubPlan, isEmailHubOnlyUpgrade, isDoubleUpgrade } =
    useUpgradePlanContext();

  const displayName = getDisplayName(plan, emailHubPlan);

  const shouldShowDowngradeFeatureList = isDowngrade(plan?.plan_action);

  const downgradeFeaturesToDisplay =
    plan?.features_lost_from_current_plan || [];

  const displaySubheading = getDisplaySubheading(
    subheading,
    isEmailHubOnlyUpgrade,
  );

  return (
    <>
      <Modal.Header>
        <Modal.Title>
          {t([i18nRoot, "downgrade_title"], {
            plan: displayName,
          })}
        </Modal.Title>

        <Modal.HeaderActions>
          <Modal.CloseButton onClick={hideModal} />
        </Modal.HeaderActions>
      </Modal.Header>
      <Modal.Body>
        {displaySubheading && (
          <div className="mb-6">
            <Typography.BodyMd color="text-default">
              {displaySubheading}
            </Typography.BodyMd>
          </div>
        )}

        <PlanLineItems />

        {!isDoubleUpgrade && shouldShowDowngradeFeatureList && (
          <div className="mt-6">
            <Typography.LabelLg weight="semibold">
              {t([i18nRoot, "you_will_lose"])}
            </Typography.LabelLg>
            <div className="mt-3">
              <PlanFeaturesList
                features={downgradeFeaturesToDisplay}
                iconType="16-close"
                iconColor="text-red-500"
              />
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer className="mt-5 flex justify-end">
        <Button variant="secondary" large onClick={onSubmitHandler}>
          {t([i18nRoot, "actions.downgrade"], { plan: displayName })}
        </Button>
      </Modal.Footer>
    </>
  );
};
